import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://c5941771b3da4968accb37839cb4a918@sentry.io/1519240',
        integrations: [new Integrations.Vue({ Vue, attachProps: true })]
    })
}
